import {
  DefaultPrivacyLevel,
  RumInitConfiguration,
} from '@datadog/browser-rum';
import { MetricsProvider } from '@primerai/ui-analytics';
import { DatadogSubscriber } from '@primerai/ui-analytics/datadog';
import config from '~/config';

const datadogConfig: RumInitConfiguration = {
  allowedTracingUrls: [
    'https://login.primer.ai',
    'https://login.dev.primering.net',
    /https:\/\/.*\.primering.net/,
  ],
  applicationId: config.VITE_DATADOG_APPLICATION_ID,
  clientToken: config.VITE_DATADOG_CLIENT_TOKEN,
  defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
  env: config.VITE_DATADOG_ENV,
  service: 'login-ui',
  sessionSampleRate: 100,
  site: config.VITE_DATADOG_SITE,
  trackUserInteractions: true,
  version: config.VERSION,
};

const TracingProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <MetricsProvider>
      <DatadogSubscriber userSettings={datadogConfig} />
      {children}
    </MetricsProvider>
  );
};

export default TracingProvider;
